/**
 * 安全的性能优化工具
 * 只包含不会导致白屏的优化措施
 */

import { initScriptEvaluationOptimization } from './scriptEvaluationOptimizer';
import { initFontOptimization } from './fontOptimizer';
import { initMobileOptimization } from './mobileOptimizer';

const fontsPath =
  process.env.NODE_ENV === 'production' ? `${process.env.PUBLIC_URL}/static` : '../assets';
/**
 * 预加载关键资源 - 安全优化
 */
export const preloadCriticalAssets = () => {
  if (typeof document === 'undefined') return;
  // 预加载关键字体
  const fonts = [
    `${fontsPath}/fonts/SourceSansPro-Regular.otf`,
    `${fontsPath}/fonts/SourceSansPro-Bold.otf`,
  ];

  fonts.forEach((font) => {
    const link = document.createElement('link');
    link.rel = 'preload';
    link.as = 'font';
    link.type = 'font/otf';
    link.href = font;
    link.crossOrigin = 'anonymous';
    document.head.appendChild(link);
  });
};

/**
 * 延迟加载第三方脚本 - 安全优化
 */
export const deferThirdPartyScripts = () => {
  if (typeof window === 'undefined') return;

  // 延迟5秒加载第三方脚本，确保不影响首屏
  setTimeout(() => {
    // Google Analytics (如果需要)
    // const gaScript = document.createElement('script');
    // gaScript.async = true;
    // gaScript.src = 'https://www.googletagmanager.com/gtag/js';
    // document.head.appendChild(gaScript);
  }, 5000);
};

/**
 * 优化图片加载 - 安全优化
 */
export const optimizeImages = () => {
  if (typeof document === 'undefined') return;

  // 在DOM加载后才执行
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyImageOptimizations);
  } else {
    applyImageOptimizations();
  }
};

const applyImageOptimizations = () => {
  const images = document.querySelectorAll('img');
  images.forEach((img, index) => {
    // 只优化前10张图片之后的图片
    if (index >= 10) {
      if (!img.loading) {
        img.loading = 'lazy';
      }
    }
  });
};

/**
 * 监控性能指标 - 只读取，不修改任何东西
 */
export const monitorPerformance = () => {
  if (typeof window === 'undefined') return;

  window.addEventListener('load', () => {
    setTimeout(() => {
      const navigation = performance.getEntriesByType('navigation')[0];
      if (!navigation) return;

      const metrics = {
        pageLoadTime: Math.round(navigation.loadEventEnd - navigation.fetchStart),
        domParseTime: Math.round(
          navigation.domContentLoadedEventEnd - navigation.domContentLoadedEventStart
        ),
        resourceLoadTime: Math.round(navigation.loadEventEnd - navigation.domContentLoadedEventEnd),
      };

      console.log('📊 页面性能指标:', metrics);
    }, 1000);
  });
};

/**
 * 初始化安全的性能优化
 */
export const initSafePerformanceOptimization = () => {
  if (typeof window === 'undefined') return;

  console.log('🛡️ 启动安全性能优化...');

  try {
    // 移动端专用优化（最高优先级）
    initMobileOptimization();

    // 字体优化（最高优先级 - 解决2.5s加载问题）
    initFontOptimization();

    // 预加载关键资源
    preloadCriticalAssets();

    // 延迟第三方脚本
    deferThirdPartyScripts();

    // 优化图片加载
    optimizeImages();

    // 监控性能
    monitorPerformance();

    // 优化Script Evaluation
    initScriptEvaluationOptimization();

    console.log('✅ 安全性能优化已启动');
  } catch (error) {
    console.warn('性能优化初始化失败:', error);
  }
};
